export const PLACEMENTS = {
    auto: { popover: 'auto', arrow: 'auto' },
    top: { popover: 'top', arrow: 'center' },
    topleft: { popover: 'top', arrow: 'left' },
    topright: { popover: 'top', arrow: 'right' },
    right: { popover: 'right', arrow: 'middle' },
    righttop: { popover: 'right', arrow: 'top' },
    rightbottom: { popover: 'right', arrow: 'bottom' },
    bottom: { popover: 'bottom', arrow: 'center' },
    bottomleft: { popover: 'bottom', arrow: 'left' },
    bottomright: { popover: 'bottom', arrow: 'right' },
    left: { popover: 'left', arrow: 'middle' },
    lefttop: { popover: 'left', arrow: 'top' },
    leftbottom: { popover: 'left', arrow: 'bottom' }
};

export type Placement = keyof typeof PLACEMENTS;

export interface VirtualReference
{
    getBoundingClientRect: () => DOMRect;
    contextElement?: Element;
}
